export const VERIFY = "/auth/v2/verify/admin";
export const BUSINESS = "/business/all";
export const ACTIVITY = (id) => "/activity/" + id;
export const CATEGORIES = "/business/preset/all";
export const BUSINESS_PRESET = "/business/preset";
export const SERVICES = "/business/services";
export const PRODUCTS = "/products";
export const PRODUCT_ID = (id) => `/products/${id}`;
export const STAFF = "/business/staff";
export const COMPLETE_PROFILE = "/business/complete-setup";
export const TIMINGS = (id, staff_id, date) =>
  "/business/" + id + "/timings/" + staff_id + "?date=" + date;
export const PLANS = "/subscription";
export const PAYMENT = "/payment/initiate";
export const PATIENTS = "/patient";
export const PATIENT_SCHEMA = "/patient/schema";

// POS Billing
export const POS_BILLING = "/pos-billing";
export const POS_BILLING_ID = (id) => `/pos-billing/${id}`;
export const POS_BILLING_PAYMENT = (id) => `/pos-billing/${id}/payment`;
export const POS_BILLING_STATISTICS = "/pos-billing/statistics";
export const BILLING = "/subscription/billing";
export const BUSINESS_FIELDS = "/business/fields";
export const BUSINESS_FIELD_ID = (id) => `/business/fields/${id}`;
export const GOOGLE_MEET_GENERATE = "/google-meet/generate";
export const GOOGLE_CALENDAR_CONNECT = "/auth/v2/register/google";
export const COUPON = "/subscription/discounts";
export const DASHBOARD = "/dashboard";
// export const SERVICE = '/business/';
export const BUSINESS_ID = (id) => "/business/" + id;
export const BUSINESS_LOGO = (id) => "/business/" + id + "/logo";
export const BUSINESS_PROFILE = "/auth/v2/verify";
export const BUSINESS_STAFF_ID = (id) => "/business/staff/web/" + id;
export const STAFF_ID = (id) => "/business/staff/all/" + id;
export const PATIENT_ID = (id) => "/patient/" + id;
// Keep CUSTOMERS for backward compatibility during migration
export const CUSTOMERS = "/patient";
export const CUSTOMER_ID = (id) => "/patient/" + id;
export const LOGIN = "/auth/v2/login/admin";
export const LOGIN_GOOGLE = "/auth/v2/login/google";
export const CALENDER_GOOGLE = "/auth/v2/register/google";
export const REGISTER = "/auth/v2/register";
export const REGISTER_VERIFY = "/auth/send-email";
export const REGISTER_VERIFY_OTP = "/auth/send-otp-verify";
export const RESET_PASSWORD = "/auth/reset-password";
export const CHANGE_PASSWORD = "/auth/change-password";
// export const CHANGE_PASSWORD=(passwordCurrent,password) =>`/auth/change-password/${passwordCurrent}/${password}`;
export const GETPAYMENTSTATUS = (id, order_ref) =>
  `/payment/status?order_id=${id}&ref_no=${order_ref}`;
export const AUTOBOOK = (id) => `/business/${id}/logo?book=0/1`;
export const APPOINTMENTS = (id) => `/appointment/v2/${id}`;
export const APPOINTMENT = `/appointment/v2`;
export const TEMPLATE = "/business/templates";
export const TEMPLATE_BIZZ = "/business/template";
export const UPLOAD_DATA = "/business/document/docs/public";
export const DELETE_SERVICE = (id) => `/business/services/${id}`;
export const DELETE_APPOINTMENT = (id) => `/appointment/${id}/delete`;
export const RESCHEDULE_APPOINTMENT = (id) => `/appointment/${id}`;
export const COMPLETE_APPOINTMENT = (id) => `/appointment/${id}`;
export const CANCEL_APPOINTMENT = (id) => `/appointment/${id}`;
export const UPDATE_APPOINTMENT_STATUS = (id) => `/appointment/${id}/status`;

export const DELETE_BUSINESS = (id) => `/admin/business/${id}/delete`;
